"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
exports.__esModule = true;
exports.errorMessages = exports.getPasswordStrength = exports.isPasswordValid = exports.checkPasswordsMatch = exports.getPasswordValidation = exports.isValidArgosEmailTopLevelDomain = exports.isValidArgosEmailCharacters = exports.isEmailBasic = exports.isEmail = exports.isCounty = exports.isCity = exports.isAddressLine2 = exports.isAddressLine = exports.isUkPostcode = exports.isPostcode = exports.isMobilePhone = exports.isUkMobilePhone = exports.isPhone = exports.isValidNectarCardNumber = exports.isLastName = exports.isFirstName = exports.isPersonTitle = exports.matchesCaseInsensitive = exports.matches = exports.hasMoreLettersThan = exports.hasMoreDigitsThan = exports.hasMoreCharactersThan = exports.hasFewerCharactersThan = exports.hasLength = void 0;
var generic_1 = require("./validators/generic");
__createBinding(exports, generic_1, "hasLength");
__createBinding(exports, generic_1, "hasFewerCharactersThan");
__createBinding(exports, generic_1, "hasMoreCharactersThan");
__createBinding(exports, generic_1, "hasMoreDigitsThan");
__createBinding(exports, generic_1, "hasMoreLettersThan");
__createBinding(exports, generic_1, "matches");
__createBinding(exports, generic_1, "matchesCaseInsensitive");
var personTitle_1 = require("./validators/personTitle");
__createBinding(exports, personTitle_1, "isPersonTitle");
var name_1 = require("./validators/name");
__createBinding(exports, name_1, "isFirstName");
__createBinding(exports, name_1, "isLastName");
var nectar_1 = require("./validators/nectar");
__createBinding(exports, nectar_1, "isValidNectarCardNumber");
var phone_1 = require("./validators/phone");
__createBinding(exports, phone_1, "isPhone");
__createBinding(exports, phone_1, "isUkMobilePhone");
__createBinding(exports, phone_1, "isMobilePhone");
var postcode_1 = require("./validators/postcode");
__createBinding(exports, postcode_1, "isPostcode");
__createBinding(exports, postcode_1, "isUkPostcode");
var address_1 = require("./validators/address");
__createBinding(exports, address_1, "isAddressLine");
__createBinding(exports, address_1, "isAddressLine2");
__createBinding(exports, address_1, "isCity");
__createBinding(exports, address_1, "isCounty");
var email_1 = require("./validators/email");
__createBinding(exports, email_1, "isEmail");
__createBinding(exports, email_1, "isEmailBasic");
__createBinding(exports, email_1, "isValidArgosEmailCharacters");
__createBinding(exports, email_1, "isValidArgosEmailTopLevelDomain");
var password_1 = require("./validators/password");
__createBinding(exports, password_1, "getPasswordValidation");
__createBinding(exports, password_1, "checkPasswordsMatch");
__createBinding(exports, password_1, "isPasswordValid");
__createBinding(exports, password_1, "getPasswordStrength");
var errorMessages_1 = require("./errorMessages");
__createBinding(exports, errorMessages_1, "errorMessages");
//# sourceMappingURL=index.js.map